import React from 'react';
import { cn } from '../lib/utils';

// Logo component with multiple variants for different contexts
const Logo = ({ 
    variant = 'full', // 'full' | 'icon' | 'wordmark'
    size = 'default', // 'small' | 'default' | 'large' | 'hero'
    className = ''
}) => {
    const sizeConfig = {
        small: {
            icon: 'h-6 w-6',
            full: 'h-6',
            text: 'text-lg',
            gap: 'gap-1.5'
        },
        default: {
            icon: 'h-8 w-8',
            full: 'h-8',
            text: 'text-xl',
            gap: 'gap-2'
        },
        large: {
            icon: 'h-10 w-10',
            full: 'h-10',
            text: 'text-2xl',
            gap: 'gap-2.5'
        },
        hero: {
            icon: 'h-16 w-16',
            full: 'h-16',
            text: 'text-4xl',
            gap: 'gap-3'
        }
    };

    const config = sizeConfig[size];

    // Shield icon SVG matching the logo design with prominent checkmark
    const ShieldIcon = ({ className: iconClass }) => (
        <svg 
            viewBox="0 0 100 120" 
            className={iconClass}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer border */}
            <path 
                d="M50 2L8 22V58C8 84 26 106 50 118C74 106 92 84 92 58V22L50 2Z" 
                fill="#0F172A"
                stroke="#FFFFFF"
                strokeWidth="3"
            />
            {/* Red top section */}
            <path 
                d="M50 8L15 25V45L50 60L85 45V25L50 8Z" 
                fill="#B91C1C"
            />
            {/* Red gradient overlay */}
            <path 
                d="M50 8L15 25V45L50 30V8Z" 
                fill="#991B1B"
            />
            {/* Dark bottom section */}
            <path 
                d="M15 45L50 60V110C30 100 15 80 15 58V45Z" 
                fill="#1F2937"
            />
            <path 
                d="M85 45L50 60V110C70 100 85 80 85 58V45Z" 
                fill="#111827"
            />
            {/* Large prominent Checkmark - centered and scaled up */}
            <path 
                d="M30 62L44 78L72 42" 
                stroke="#FFFFFF"
                strokeWidth="10"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );

    // Wordmark matching the logo typography
    const Wordmark = ({ className: textClass }) => (
        <span className={cn("font-heading font-black tracking-tight", textClass)}>
            <span className="text-[#B91C1C]">CLIENT</span>
            <span className="text-white bg-[#111827] px-1.5 py-0.5 -ml-0.5">CHECK</span>
        </span>
    );

    if (variant === 'icon') {
        return <ShieldIcon className={cn(config.icon, className)} />;
    }

    if (variant === 'wordmark') {
        return <Wordmark className={cn(config.text, className)} />;
    }

    // Full logo with icon + wordmark
    return (
        <div className={cn("flex items-center", config.gap, className)}>
            <ShieldIcon className={config.icon} />
            <Wordmark className={config.text} />
        </div>
    );
};

export default Logo;
